import React, { useState } from 'react';
import './Resources.css';

const PeakResourcesPage = () => {
  const [activeTab, setActiveTab] = useState('Data');

  const tabs = ['Data', 'Send Rewards', 'SMS', 'API 4', 'API 5', 'API 6'];

  return (
    <div className="peak-resources-page">

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1 className="page-title">Resources</h1>
          <p className="page-subtitle">We believe in the power of play to drive deeper customer engagement.</p>
        </div>
      </section>

      {/* API Section */}
      <section className="api-section">
        <div className="container">
          <h2 className="section-title">Our APIs</h2>
          
          {/* API Tabs */}
          <div className="api-tabs">
            {tabs.map(tab => (
              <button 
                key={tab} 
                className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          
          {/* API Content */}
          <div className="api-content">
            <div className="api-card">
              <div className="api-header">
                <h3>Data API <span className="access-badge">Full Access</span></h3>
                <p className="creation-date">Created on 28 Apr 2024, 18:20</p>
              </div>
              <div className="api-cta">
                <button className="sign-in-access-btn">
                  Sign In to Access <span className="arrow-icon">→</span>
                </button>
              </div>
            </div>
          </div>
          
          {/* Documentation and Best Practices */}
          <div className="info-cards">
            <div className="info-card">
              <h3>Documentation</h3>
              <p>We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency.</p>
            </div>
            <div className="info-card">
              <h3>Best Practices</h3>
              <p>We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency We focus on clean code, consistency.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PeakResourcesPage;